import { PostTask } from "../../../services/fhir/task/PostTask";
import { ITaskData } from "../../../utils/interfaces";

/**
 * Cria uma tarefa para medicamento
 * @param fullData Dados completos do medicamento
 * @param userName Nome do usuário atual
 * @returns Task criada
 */
export async function CreateMedicationTask(fullData: any, userName: string) {
  try {
    // Extrai os dados necessários do objeto fullData
    const patientReference = fullData?.subject?.reference;
    const professionalReference = fullData?.informationSource?.[0]?.reference;
    const medicationName = fullData?.medication?.concept?.text;
    const noteText = fullData?.note?.[0]?.text;

    // Verifica se os dados obrigatórios estão presentes
    if (!patientReference || !professionalReference || !medicationName) {
      console.error("CreateMedicationTask: Dados obrigatórios ausentes");
      throw new Error("Dados obrigatórios ausentes");
    }

    // Prepara os dados da tarefa
    const codeValue = noteText ? `Observação do paciente: ${noteText}` : "";
    
    // Cria o objeto taskData com todos os campos necessários
    const taskData: ITaskData = {
      status: "requested",
      intent: "order",
      priority: "routine",
      description: `O paciente ${userName} alterou o uso do medicamento ${medicationName}`,
      // Inclui o campo code apenas se tiver uma observação do paciente
      ...(codeValue ? {
        code: {
          text: codeValue,
          coding: [
            {
              system: "https://fluxmed.com.br/fhir/CodeSystem/task-types",
              code: "NOTIFICATION_DOCUMENT"
            }
          ]
        }
      } : {}),
      owner: patientReference,
      for: professionalReference,
    };

    // Cria a tarefa utilizando o PostTask
    const response = await PostTask(taskData);
    return response;
  } catch (error) {
    console.error("CreateMedicationTask:", error);
    throw error;
  }
}